import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export type PlantAssetDetailMode = 'AREAS' | 'STATUS';

export default class PlantAssetsShowIndexController extends Controller {
  @tracked mode?: PlantAssetDetailMode;
  queryParams = ['mode'];
}
